import styled from "styled-components";
import { Menu } from "antd";

const StyledMenu = styled(Menu)`
  background: transparent;
  border-right-color: transparent !important;
  display: flex;
  flex-direction: column;
  gap: 2px;
  width: 100%;

  &::before {
    display: none;
  }

  .ant-menu-item {
    margin: 2px 0;
    width: 100%;

    .ant-menu-title-content {
      align-items: center;
      display: flex;
      gap: 12px;
    }
  }

  .container-sidebar-icon {
    display: flex;
    gap: 12px;
    justify-content: center;
    width: 22px;
  }
`;

export default StyledMenu;
